import { postCombo, patchCombo ,getComboById} from "../../services/ArticulosCombosServices"
import { ArticulosCombosFormContext } from "./ArticulosCombosContext"

export const ArticulosCombosFormState = ({ children }) => {

    const getArticuloComboByIdData = async (id) => {
        let res = await getComboById(id)
        
        return res
    }

    const postArticuloComboData = async (body) => {
        const res = await postCombo(body)
        return res
    }

    const patchArticuloComboData = async (id, body) => {
        const res = await patchCombo(id, body)
        return res
    }

    return <ArticulosCombosFormContext.Provider value={{
        postArticuloComboData,
        patchArticuloComboData,
        getArticuloComboByIdData,
    }} >
        {children}
    </ArticulosCombosFormContext.Provider>
}